// Curated content for the Cowrieking website. All placeholder imagery is African documentary work
// generated for this site — every image below is replaceable from the Admin dashboard.

const IMG = "https://static.prod-images.emergentagent.com/jobs/044129a6-116c-4bc2-ad36-aa46b4cd58c6/images";
export const IMAGES = {
  heroSignature: `${IMG}/daed7efc0f68fe2fb8fff53ca20041141fb6a3c5b61aeab7e8cb77091e42a377.png`,
  waterLife: `${IMG}/28dd368d5bd05c877d7b64ffb072b9b68d140c0d67775beb0ccddea6c00c9133.png`,
  fishermenDawn: `${IMG}/c591339fd1b3548a106dd8624c4e8146aa7a238675166360a9e4951617bfac24.jpeg`,
  elderPortrait: `${IMG}/c2d58989456a81edb569dbc367a1979b3e3f069e7c96b1375aa9d1a56b479827.jpeg`,
  childrenHope: `${IMG}/e552cd3ad638b75a34d09b0440954a2feb603f2a23c5b197f363f77fcc78835d.jpeg`,
  jamestown: `${IMG}/fafbf6f954a73b9bc0316a1ae7ed380423784e1934762f01b4f025de0538b753.jpeg`,
  kenteWeaver: `${IMG}/8ffc0c368b47233f0bca468f4647e13f0361dcc0ad7301a94246dff192bc97d7.jpeg`,
  asafoWarriors: `${IMG}/262d2a119ea065c60d4574f67dd6758acb405be3e4d42c7dedd851228252a681.jpeg`,
  marketWoman: `${IMG}/39c77fffcf176042649a18de588ef05956f2417f68ea4fc8f2e0b54b9abac741.jpeg`,
  voltaCanoe: `${IMG}/dd95f5574aa634a073683b2cb578488d724a3f17f2791545c7e26942d3baa30f.jpeg`,
  cowriesBW: `${IMG}/9a71607853e657533e7260a260278b3d5486c4131f940732b9b328ea8986d4b3.jpeg`,
  jollof: `${IMG}/01ba5caf069adaad6260d044c68c327d36e59d2398c525ed984b3fd7ae88c9ae.jpeg`,
  photographer: `${IMG}/2302b9c2a63ea6153c49e469035a0303db06cd1f59fc820a8a42cd1464a95901.jpeg`,
  festivalDrummers: `${IMG}/c94c05c03f6f6a4c5742965e4bd9e5bdf2270e9569dad3b6f4d93a68202b4eb9.jpeg`,
  estuaryAerial: `${IMG}/0a40d7684b59bb2917c796195a6a630a9a2be96189c28bff33c792ce25e64a4f.jpeg`,
  capeCoast: `${IMG}/74066a4001b156d6e1779c9e7fecc12dd164563b74a6eb6652c6c0c260c1d199.jpeg`,
  journalFlatlay: `${IMG}/42c2526f2bee07286e9ff76fd8de4e5e5fdf946ea3f37e210b6fc342083d61d5.jpeg`,
};

export const HERO_SLIDES = [
  {
    image: IMAGES.heroSignature,
    caption: "Storyteller. Witness. Healer.",
    location: "Ada Foah, Ghana",
  },
  {
    image: IMAGES.fishermenDawn,
    caption: "Where tradition meets the sea.",
    location: "Volta Region, Ghana",
  },
  {
    image: IMAGES.childrenHope,
    caption: "Every face is a country I've yet to map.",
    location: "Greater Accra",
  },
  {
    image: IMAGES.festivalDrummers,
    caption: "Color, ceremony, soul.",
    location: "Northern Ghana",
  },
];

export const COLLECTIONS = [
  {
    slug: "soul-of-africa",
    title: "The Soul of Africa",
    subtitle: "Street photography, traditions, daily life",
    cover: IMAGES.jamestown,
    description: "From the dawn markets of Makola to the dust-painted footsteps of village elders, this collection holds the living pulse of a continent that refuses to be reduced.",
    count: 48,
    images: [
      IMAGES.jamestown,
      IMAGES.marketWoman,
      IMAGES.kenteWeaver,
      IMAGES.festivalDrummers,
      IMAGES.voltaCanoe,
      IMAGES.capeCoast,
    ],
  },
  {
    slug: "faces-of-humanity",
    title: "Faces of Humanity",
    subtitle: "Raw emotional portraits",
    cover: IMAGES.elderPortrait,
    description: "Portraiture as prayer. Each frame an offering — not to capture a person, but to be allowed near their soul.",
    count: 36,
    images: [
      IMAGES.elderPortrait,
      IMAGES.marketWoman,
      IMAGES.childrenHope,
      IMAGES.cowriesBW,
      IMAGES.kenteWeaver,
      IMAGES.asafoWarriors,
    ],
  },
  {
    slug: "children-of-hope",
    title: "Children of Hope",
    subtitle: "Stories of resilience and innocence",
    cover: IMAGES.childrenHope,
    description: "They have nothing — and they have everything. Children carry the entire architecture of African tomorrow in their laughter.",
    count: 52,
    images: [
      IMAGES.childrenHope,
      IMAGES.jamestown,
      IMAGES.fishermenDawn,
      IMAGES.estuaryAerial,
      IMAGES.marketWoman,
      IMAGES.festivalDrummers,
    ],
  },
  {
    slug: "sacred-traditions",
    title: "Sacred Traditions",
    subtitle: "Festivals, chiefs, rituals, spirituality",
    cover: IMAGES.asafoWarriors,
    description: "Asafotufiami. Hogbetsotso. Homowo. The drum remembers what books cannot. These photographs are devotional acts.",
    count: 41,
    images: [
      IMAGES.asafoWarriors,
      IMAGES.festivalDrummers,
      IMAGES.kenteWeaver,
      IMAGES.elderPortrait,
      IMAGES.cowriesBW,
      IMAGES.capeCoast,
    ],
  },
  {
    slug: "life-by-the-water",
    title: "Life by the Water",
    subtitle: "Ada fishermen, Volta River, sea culture",
    cover: IMAGES.waterLife,
    description: "Where the Volta meets the Atlantic, my people have built lives on rhythm — of tide, of net, of song.",
    count: 34,
    images: [
      IMAGES.waterLife,
      IMAGES.fishermenDawn,
      IMAGES.voltaCanoe,
      IMAGES.estuaryAerial,
      IMAGES.capeCoast,
      IMAGES.cowriesBW,
    ],
  },
  {
    slug: "black-and-white-stories",
    title: "Black & White Stories",
    subtitle: "Timeless emotional documentary work",
    cover: IMAGES.cowriesBW,
    description: "Stripped of color, what remains is bone, breath, and bearing. The architecture of feeling.",
    count: 28,
    images: [
      IMAGES.cowriesBW,
      IMAGES.elderPortrait,
      IMAGES.fishermenDawn,
      IMAGES.jamestown,
      IMAGES.asafoWarriors,
      IMAGES.voltaCanoe,
    ],
  },
];

export const BLOG_POSTS = [
  {
    slug: "the-cowrie-and-the-camera",
    title: "The Cowrie and the Camera",
    excerpt: "On inheritance, identity, and the small things we carry across oceans of memory.",
    cover: IMAGES.cowriesBW,
    date: "Nov 14, 2025",
    category: "Philosophy",
    read: "8 min read",
    content: `My grandmother kept three cowries in a small tin beside her bed. They were never wealth — they were witnesses. She had carried them from her own mother's hands, and her mother before her.\n\nWhen I picked up a camera for the first time, I understood. A photograph is a cowrie. It is small. It can fit in your palm. But it carries everything — a face, a sky, a particular afternoon that will never come again.\n\nIn my work, I do not chase the spectacular. I chase the cowrie moments — the inheritance hiding in ordinary light.`,
  },
  {
    slug: "ada-foah-fishermen-songs",
    title: "Songs the Fishermen Still Sing",
    excerpt: "A morning with the men who pull the Volta open before sunrise.",
    cover: IMAGES.fishermenDawn,
    date: "Oct 28, 2025",
    category: "Documentary",
    read: "6 min read",
    content: `At 4:47 a.m., the estuary at Ada is a sheet of silver. The men have already been awake an hour, mending nets by lamplight. They sing as they push the boat out — not for me, not for tradition's sake, but because singing is how the sea is asked permission.`,
  },
  {
    slug: "humanity-over-ego",
    title: "Humanity Over Ego: Notes from the Field",
    excerpt: "Why I lower the camera more often than I raise it.",
    cover: IMAGES.elderPortrait,
    date: "Oct 02, 2025",
    category: "Essays",
    read: "5 min read",
    content: `The best photograph I never took was of a woman in Bawku, weeping over a letter. I lowered the camera. I sat down. We drank water together for forty minutes. That is the photograph. The camera was incidental.`,
  },
  {
    slug: "africa-is-not-a-mood",
    title: "Africa Is Not a Mood",
    excerpt: "On the violence of romanticization and the discipline of seeing.",
    cover: IMAGES.jamestown,
    date: "Sep 19, 2025",
    category: "Pan-African Thought",
    read: "9 min read",
    content: `Sepia. Slow drums. A child running into the sunset. The Western lens has built an entire visual grammar that flattens 1.4 billion people into a feeling. I refuse to translate my home into anyone else's nostalgia.`,
  },
  {
    slug: "children-i-have-photographed",
    title: "The Children I Have Photographed",
    excerpt: "Six years later, where are they now? An Eyes of Hope follow-up.",
    cover: IMAGES.childrenHope,
    date: "Aug 30, 2025",
    category: "Eyes of Hope",
    read: "11 min read",
    content: `In 2019, I photographed seventeen children in a schoolyard in Sogakope. This year, I returned. Eleven are still in school. Three have graduated. Two work as teachers. One is studying medicine in Cape Coast. This is what a photograph can do when it does not stay flat.`,
  },
  {
    slug: "asafotufiami-festival",
    title: "Asafotufiami: The Festival of Warriors",
    excerpt: "Inside the most sacred annual gathering of the Ada people.",
    cover: IMAGES.asafoWarriors,
    date: "Aug 12, 2025",
    category: "Culture",
    read: "7 min read",
    content: `Every August, the Ada people gather. Warriors. Chiefs. Drums older than the colonial map. To photograph this is to be permitted into a room you can never own.`,
  },
];

export const PRINTS = [
  {
    slug: "the-net-mender",
    title: "The Net Mender",
    edition: "Edition of 25 · Archival pigment print",
    sizes: ["30×40 cm", "60×80 cm", "100×140 cm"],
    price: 480,
    image: IMAGES.fishermenDawn,
    benefits: "100% of proceeds support fishermen's literacy in Ada Foah.",
  },
  {
    slug: "morning-prayer",
    title: "Morning Prayer",
    edition: "Edition of 15 · Hahnemühle Photo Rag",
    sizes: ["40×50 cm", "70×90 cm"],
    price: 720,
    image: IMAGES.elderPortrait,
    benefits: "Supports the woman photographed and her family directly.",
  },
  {
    slug: "asafo-drummer",
    title: "Asafo Drummer",
    edition: "Edition of 20 · Archival cotton",
    sizes: ["50×70 cm", "80×120 cm"],
    price: 560,
    image: IMAGES.festivalDrummers,
    benefits: "Funds the Ada cultural archive project.",
  },
  {
    slug: "the-girl-with-the-lantern",
    title: "The Girl with the Lantern",
    edition: "Edition of 10 · Silver gelatin",
    sizes: ["40×60 cm", "70×100 cm"],
    price: 1280,
    image: IMAGES.childrenHope,
    benefits: "Funds a full secondary-school scholarship.",
  },
  {
    slug: "elder-in-blue",
    title: "Elder in Blue",
    edition: "Edition of 30 · Archival pigment",
    sizes: ["30×40 cm", "60×80 cm"],
    price: 420,
    image: IMAGES.marketWoman,
    benefits: "Supports elder care in the Volta Region.",
  },
  {
    slug: "the-river-knows",
    title: "The River Knows",
    edition: "Edition of 12 · Diasec mounted",
    sizes: ["80×120 cm", "120×180 cm"],
    price: 1850,
    image: IMAGES.waterLife,
    benefits: "Funds clean water access in three coastal villages.",
  },
];

export const VOICES = [
  {
    name: "Adzo, 67",
    location: "Ada Foah, Ghana",
    image: IMAGES.elderPortrait,
    quote: "Mershack did not take my picture. He sat with me for two days. On the third morning, I asked him to take it.",
    story: "I am a widow. My husband fished the Volta for fifty-one years. When he died, the boys came with cameras and microphones and they all left in an afternoon. Mershack stayed. He drank my pepper soup. He listened to my Anlo. He photographed me only after he knew my name and the name of my mother and the name of the river I was born next to. That is the difference.",
  },
  {
    name: "Kwesi, 12",
    location: "Sogakope, Volta Region",
    image: IMAGES.childrenHope,
    quote: "Before he came, I did not know my face was something beautiful.",
    story: "I want to be a doctor. Mershack and Eyes of Hope are paying my school fees from the print of my photograph. He sends me the book of pictures every Christmas. My grandmother keeps it under her pillow.",
  },
  {
    name: "Naa Adoley, 41",
    location: "Jamestown, Accra",
    image: IMAGES.marketWoman,
    quote: "He photographed me as a market woman. He photographed me as a queen.",
    story: "Many photographers come to Jamestown. They photograph the smoke and the rust. Mershack photographed my face. He sent the printed photograph to my house. It hangs above my doorway. People stop. They look. They greet me differently now.",
  },
];

export const TIMELINE = [
  { year: "1991", title: "Born in Ada Foah", body: "The estuary, the salt, the songs of the fishermen — Mershack's first language." },
  { year: "2003", title: "First camera", body: "A neighbour's broken Yashica. Six exposures. One survived. It changed everything." },
  { year: "2009", title: "First exhibition", body: "Untitled — twelve portraits of his grandmother. Shown in a borrowed schoolroom." },
  { year: "2014", title: "Adanobi Studios founded", body: "A creative house dedicated to African storytelling, portraiture, and documentary work." },
  { year: "2017", title: "Eyes of Hope Foundation", body: "Photographs began funding the lives they captured. Forty-seven children sponsored in year one." },
  { year: "2021", title: "Featured globally", body: "Work acquired by private collections in Lagos, London, Brooklyn, and Cape Town." },
  { year: "2025", title: "The Cowrieking Movement", body: "A digital ecosystem — art, archive, advocacy, and impact — finally under one roof." },
];

export const PHILOSOPHY_PILLARS = [
  { number: "01", title: "Humanity Over Ego", body: "I lower the camera more often than I raise it. The subject is sovereign. Always." },
  { number: "02", title: "Culture as Living Body", body: "African culture is not a museum. It breathes. It changes. It must be photographed accordingly." },
  { number: "03", title: "Storytelling as Healing", body: "When a community sees itself with dignity, something inside it begins to mend." },
  { number: "04", title: "African Identity", body: "I work for the eye that comes after me — for the Ghanaian child who will one day Google their own face." },
  { number: "05", title: "Spiritual Depth", body: "Every frame is a prayer. Every light a gift. Every silence a teacher." },
  { number: "06", title: "Service to Community", body: "If my photograph cannot feed, school, clothe, or dignify — what is it for?" },
];

export const SERVICES = [
  { title: "Portrait Photography", description: "Editorial and personal portraiture with the depth of a documentary frame.", price: "from $850" },
  { title: "Documentary Projects", description: "Long-form visual storytelling for NGOs, foundations, and cultural institutions.", price: "by inquiry" },
  { title: "Weddings & Events", description: "Cinematic, intimate documentation of life's defining moments.", price: "from $2,400" },
  { title: "Brand Storytelling", description: "Africa-rooted brand films and stills that travel with integrity.", price: "from $3,200" },
  { title: "Cultural Documentation", description: "Festivals, ceremonies, archives for cultural institutions and museums.", price: "by inquiry" },
  { title: "Creative Consulting", description: "Visual strategy and creative direction for purpose-led organizations.", price: "from $1,200" },
];
